import { CodedProperty, NamedProperty } from "sprint-common-web";

import { OrderRequestListItemResponse } from "../../../common/api/orders-api/order-request/GetOrderRequestListResponse";
import { OrderContentReference } from "../../../common/types/OrderContentReference";

export interface LookupOrderItem {
    id: string;
    pONumber: string;
    content?: OrderContentReference;
    airline?: CodedProperty;
    system?: NamedProperty;
    createdDate: string;
}

export const mapToLookupOrderItem = (response: OrderRequestListItemResponse): LookupOrderItem => {
    return {
        id: response.id,
        content: response.content,
        airline: response.airline,
        system: response.systemPlatform?.system,
        pONumber: response.pONumber,
        createdDate: response.audit.createdDate
    };
};
